export default __webpack_public_path__ + "static/media/portfolio-3.578fa408.jpg";